export default __webpack_public_path__ + "static/media/IMG_20190409_131530.69bbcfc8.jpg";